import { ChangePAYGCredit, UserFeature } from "../constants/api-urlConstants";
import { ROLES } from "../constants/commonConstants";

export const publicDomainUrl = 'https://infraclear.com'; // 'http://localhost:5173'

export const DOC_SEARCH_ONLY_USER_ROLES = [
  ROLES.CONTRACTS_TRAIL,
  ROLES.FINANCIAL_MODELS_TRAIL,
  ROLES.CONTRACTS_SUBSCRIBER,
  ROLES.FINANCIAL_MODEL_SUBSCRIBER,
  ROLES.SALES_REPRESENTATIVE,
  ROLES.GUEST,
  ROLES.DATA_BROWSER_USER,
  ROLES.DATA_BROWSER_SUPER_USER
];

export const DOC_VERIFICATION_ONLY_USER_ROLES = [
  ROLES.DOC_VERIFICATION_USER
];

export const PAYG_USER_ROLES = [
  ROLES.PAYG_USER,
  ROLES.PAYG_TEAM_ADMIN
]

export const FEATURE_LIMIT_CONFIG: any = {
  CHAT: {
    label: 'Chat Limit',
    messageLable: 'Chat limit',
    featureType: 'CHAT',
    api: UserFeature,
    isUnlimit: true
  },
  FREE_RENTAL: {
    label: 'Free Rental Credit',
    messageLable: 'Free rental credit',
    api: ChangePAYGCredit
  },
  FREE_CHAT: {
    label: 'Free Chat Credit',
    messageLable: 'Free chat credit',
    api: ChangePAYGCredit
  },
  FREE_BUY: {
    label: 'Free Downloadable Credit',
    messageLable: 'Free downloadable credit',
    api: ChangePAYGCredit
  }
};

export const DISABLE_ROLES = [
  ROLES.PAYG_USER,
  ROLES.PAYG_TEAM_ADMIN,
  ROLES.SUPER_ADMIN
];